import { TAG_TYPES, FormatResponse } from "types";
import { baseApi } from "./baseApi";

const URL_DOCUMENTS = "documents";

export interface DocumentRecord {
  id: string;
  fileName: string;
  fileUrl: string;
  documentType: string;
  note: string | null;
  userId: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface CreateDocumentPayload {
  fileName: string;
  fileUrl: string;
  documentType: string;
  note?: string;
}

const documentApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Create document record in DB
    createDocument: builder.mutation<
      FormatResponse<DocumentRecord>,
      CreateDocumentPayload
    >({
      query: (data) => ({
        url: URL_DOCUMENTS,
        method: "POST",
        data,
      }),
      invalidatesTags: [{ type: TAG_TYPES.DOCUMENT, id: "LIST" }],
    }),
  }),
});

export const { useCreateDocumentMutation } = documentApiService;
